// extracted by mini-css-extract-plugin
var _1 = "CalendarGridDayChips-modulemore__rj2m8";
export { _1 as "more" }
